import { extractSignatureFromTransaction, extractSignaturesFromTransactions } from './SolanaUtils';
/**
 * Formats the provider response based on the RPC method
 * @param response - Raw response from the provider
 * @param method - RPC method name
 * @returns Formatted response
 */
export function formatRpcResponse(response, method) {
    if (method === 'solana_signTransaction') {
        if (response && typeof response === 'object' && 'transaction' in response) {
            const transactionBase58 = response.transaction;
            const signatureBase58 = extractSignatureFromTransaction(transactionBase58);
            return { signature: signatureBase58 };
        }
    }
    if (method === 'solana_signAllTransactions') {
        if (response && typeof response === 'object' && 'transactions' in response) {
            const transactionsBase58 = response.transactions;
            const signaturesBase58 = extractSignaturesFromTransactions(transactionsBase58);
            return { signatures: signaturesBase58 };
        }
    }
    return response;
}
//# sourceMappingURL=ResponseUtils.js.map